export default function Utils() {
  // ###################################################################
  // ########################### PROTOCOL ##############################
  // ###################################################################
  /*
    Returns the current height of the browser area that can render a page's content
    Offers support for older versions of Internet Explorer
  */
  this.getBrowserWindowHeight = function () {
    let windowHeight = 0;
    if (typeof (window.innerWidth) == "number") {
      //Non-IE
      windowHeight = window.innerHeight;
    } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
      //IE 6+ in 'standards compliant mode'
      windowHeight = document.documentElement.clientHeight;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
      //IE 4 compatible
      windowHeight = document.body.clientHeight;
    }
    return (windowHeight);
  };

  // Checks if the POST configuration message was received succesfully by the backend
  this.checkStatus = function (response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      let error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  };

  // Checks if the POST configuration message was received succesfully by the backend
  this.checkStatus2 = async function (response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      let errorText = await response.text();
      let error = new Error(errorText);
      error.response = response;
      throw error;
    }
  };

  this.sortBy = function (field, reverse, primer) {

    let key = primer ?
      function (x) { return primer(x[field]); } :
      function (x) { return x[field]; };

    reverse = !reverse ? 1 : -1;

    return function (a, b) {
      // eslint-disable-next-line
      return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
    };
  };

  // Returns the uppercase of a string only if it not null or undefined
  this.treatUppercase = function (str) {
    if (undefined !== str && null !== str) {
      return str.toUpperCase();
    } else {
      return " ";
    }
  };

  this.validateIPAddress = function (ipAddress) {
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipAddress)) {
      return true;
    }
    else {
      return false;
    }
  };

  this.validateSubmask = function (submask) {
    // eslint-disable-next-line
    let submaskRegex = new RegExp("^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$");
    return (submaskRegex.test(submask));
  };

  // Returns true if the IP is localhost (127.0.0.1)
  this.isIPLoopback = function (ipAddress) {
    if (ipAddress === "127.0.0.1") {
      return true;
    }
    else {
      return false;
    }
  };

  this.ipToBinary = (ip) => {
    return ip.split(".")
      .map(octet => parseInt(octet, 10).toString(2).padStart(8, "0"))
      .join(".");
  };

  this.calculateNetworkAddress = (ip, subnetMask, UtilsInstance) => {
    const ipBinary = UtilsInstance.ipToBinary(ip).split(".");
    const maskBinary = UtilsInstance.ipToBinary(subnetMask).split(".");
    const networkAddress = ipBinary.map((octet, index) => {
      return (parseInt(octet, 2) & parseInt(maskBinary[index], 2)).toString(2).padStart(8, "0");
    }).join(".");

    return networkAddress;
  };

  this.isSameNetwork = (ip1, ip2, subnetMask, UtilsInstance) => {
    const networkAddress1 = UtilsInstance.calculateNetworkAddress(ip1, subnetMask, UtilsInstance);
    const networkAddress2 = UtilsInstance.calculateNetworkAddress(ip2, subnetMask, UtilsInstance);
    return networkAddress1 === networkAddress2;
  };

  this.ipToInteger = (ip) => {
    return ip.split(".").reduce((int, octet) => (int << 8) + parseInt(octet, 10), 0);
  };

  this.calculateRange = (subnetIp, mask, UtilsInstance) => {
    const networkAddress = UtilsInstance.calculateNetworkAddress(subnetIp, mask, UtilsInstance);
    const invertedMask = mask.split(".").map(octet => 255 - parseInt(octet, 10)).join(".");
    const networkInt = UtilsInstance.ipToInteger(networkAddress.split(".").map(octet => parseInt(octet, 2).toString(10)).join("."));
    const broadcastInt = networkInt + UtilsInstance.ipToInteger(invertedMask);
    return [networkInt, broadcastInt];
  };

  this.subnetsOverlap = (subnetIp1, mask1, subnetIp2, mask2, UtilsInstance) => {
    const [range1Start, range1End] = this.calculateRange(subnetIp1, mask1, UtilsInstance);
    const [range2Start, range2End] = this.calculateRange(subnetIp2, mask2, UtilsInstance);
    return range1Start <= range2End && range2Start <= range1End;
  };

  // Funções para o cálculo de endereço de broadcast e endereço da rede
  this.ipToBinary2 = (ip) => {
    return ip.split(".").map(function (num) {
      return ("00000000" + parseInt(num, 10).toString(2)).slice(-8);
    }).join("");
  };

  this.binaryToIp = (binary) => {
    return binary.match(/.{1,8}/g).map(function (bin) {
      return parseInt(bin, 2).toString();
    }).join(".");
  };

  this.calculateNetworkAddress2 = (ipBinary, maskBinary) => {
    let networkBinary = "";
    for (let i = 0; i < 32; i++) {
      networkBinary += (ipBinary[i] === "1" && maskBinary[i] === "1") ? "1" : "0";
    }
    return networkBinary;
  };

  this.calculateBroadcastAddress = (networkBinary, maskBinary) => {
    let broadcastBinary = "";
    for (let i = 0; i < 32; i++) {
      broadcastBinary += (maskBinary[i] === "0") ? "1" : networkBinary[i];
    }
    return broadcastBinary;
  };

  this.isBroadcastAddress = function (ip, subnetMask, UtilsInstance) {
    const ipBinary = UtilsInstance.ipToBinary2(ip);
    const maskBinary = UtilsInstance.ipToBinary2(subnetMask);
    const networkBinary = UtilsInstance.calculateNetworkAddress2(ipBinary, maskBinary);
    const broadcastBinary = UtilsInstance.calculateBroadcastAddress(networkBinary, maskBinary);
    const broadcastAddress = UtilsInstance.binaryToIp(broadcastBinary);

    console.log("broadcastAddress: ", broadcastAddress);
    return ip === broadcastAddress;
  };

  this.isNetworkAddress = function (ip, subnetMask, UtilsInstance) {
    if (ip === "0.0.0.0") {
      return false;
    }

    const ipBinary = UtilsInstance.ipToBinary2(ip);
    const maskBinary = UtilsInstance.ipToBinary2(subnetMask);
    const networkBinary = UtilsInstance.calculateNetworkAddress2(ipBinary, maskBinary);
    const networkAddress = UtilsInstance.binaryToIp(networkBinary);

    console.log("networkAddress: ", networkAddress);
    return ip === networkAddress;
  };

  this.removeLeadingZeros = (fullIpAddress, UtilsInstance) => {
    if (fullIpAddress === "") {
      console.log("IP em branco, retorna IP em branco");
      return "";
    }
    else {
      let cleanedIp = fullIpAddress.split(".").map((ipPart) => {
        return parseInt(ipPart, 10);
      }).join(".");

      if (!UtilsInstance.validateIPAddress(cleanedIp)) {
        console.log("Caso de IP invalido, retorna o próprio texto passado como entrada");
        console.log("fullIpAddress", fullIpAddress);
        return fullIpAddress;
      }
      else {
        console.log("Caso de IP valido, retorna o IP sem os zeros à esquerda");
        console.log("cleanedIp", cleanedIp);
        return cleanedIp;
      }
    }
  };

  this.validadeHostnameLength = function (hostname) {
    return (hostname.length >= 2) && (hostname.length <= 64);
  };

  // Hostname must start with a letter or a number, can have letters, numbers,
  // dot and hyphen, and must end with a letter or number
  // This validation is a simplification of the hostname regex, it is not perfect.
  // It allows for hostnames like: as...fg, which is not a valid hostname
  // However the the return of the webservice will say if the hostname was accepted or not
  this.simpleValidadeHostname = function (hostname) {
    const nameRegex = new RegExp("^[A-Za-z0-9][A-Za-z0-9/./-]*[A-Za-z0-9]$");
    return nameRegex.test(hostname);
  };

  this.isZeroIP = function (ipAddress) {
    if (ipAddress === "0.0.0.0") {
      return true;
    }
    else {
      return false;
    }
  };

  // ###################################################################
  // ########################### ANALYZER DP ###########################
  // ###################################################################

  /// ---------------- Adjust Chart Height ----------------
  this.adjustChartHeight = function () {
    const browserHeight = this.getBrowserWindowHeight();

    if (browserHeight >= 950) {
      return "600px";
    }
    else if (browserHeight >= 800 && browserHeight < 950) {
      return "540px";
    }
    else if (browserHeight >= 600 && browserHeight < 800) {
      return "420px";
    }
    else {
      return "250px";
    }
  };

  this.adjustOscilloscopeChartHeight = function () {
    const browserHeight = this.getBrowserWindowHeight();

    if (browserHeight >= 900) {
      return "370px";
    }
    else if (browserHeight >= 800 && browserHeight < 900) {
      return "340px";
    }
    else if (browserHeight >= 700 && browserHeight < 800) {
      return "270px";
    }
    else if (browserHeight >= 600 && browserHeight < 700) {
      return "230px";
    }
    else {
      return "205px";
    }
  };

  this.getMasterSuffix = function (isMaster) {
    if (isMaster) {
      return " - Mestre";
    }
  };

  this.getFormatedAmplitude = function (deviceAmplitude) {
    if (deviceAmplitude > 0) {
      let sum = 0;
      let num = parseFloat(deviceAmplitude.toFixed(2)) * 100;
      let numString = num.toFixed(0);

      for (let k = 0; k < numString.length; k++) {
        sum += parseInt(numString[k], 10);
      }

      if (sum % 2 !== 0) {
        if (num === 349 || num === 749 || num === 249) {
          num = num - 1;
        }
        else {
          if (numString[numString.length - 1] === "9") {
            num = num - 1;
          }
          else {
            num = num + 1;
          }
        }
      }

      return (num / 100).toFixed(2);
    }
    else {
      return deviceAmplitude;
    }
  };

  this.getBarGraphColorBasedOnValue = function (value, Constants) {
    if (value > 0) {
      let numString = (value * 100).toFixed(0).toString();
      let sum = 0;
      let isFaded = false;

      for (let k = 0; k < numString.length; k++) {
        sum += parseInt(numString[k], 10);
      }

      if (sum % 2 === 0) {
        isFaded = false;
      }
      else {
        isFaded = true;
      }

      if (isFaded) {
        if (value >= 4 && value <= 7) {
          return Constants.FADED_GREEN_HEX; // verde
        }
        else if (value > 7 && value <= 8) {
          return Constants.FADED_YELLOW_HEX; // amarelo 
        }
        else if (value >= 3 && value < 4) {
          return Constants.FADED_YELLOW_HEX; // amarelo 
        }
        else if (value < 3 || value > 8) {
          return Constants.FADED_RED_HEX; // vermelho
        }
      }
      else {
        if (value >= 4 && value <= 7) {
          return Constants.GREEN_HEX; // verde
        }
        else if (value > 7 && value <= 8) {
          return Constants.YELLOW_HEX; // amarelo 
        }
        else if (value >= 3 && value < 4) {
          return Constants.YELLOW_HEX; // amarelo 
        }
        else if (value < 3 || value > 8) {
          return Constants.RED_HEX; // vermelho
        }
      }
    }
    else {
      return Constants.RED_HEX;
    }
  };

  this.excludeEmptyWaves = function (waves) {
    let wavesToShow = [];

    for (let i = 0; i < waves.length; i++) {
      if (waves[i].wave.length > 0) {
        wavesToShow.push(waves[i]);
      }
    }

    return wavesToShow;
  };

  this.addTagToDevices = (livelist, liveListMonitor) => {
    let modifiedLiveList = JSON.parse(JSON.stringify(livelist));

    for (let i = 0; i < modifiedLiveList.length; i++) {
      modifiedLiveList[i].tag = "";

      for (let j = 0; j < liveListMonitor.length; j++) {
        if (modifiedLiveList[i].address === liveListMonitor[j].address) {
          if (liveListMonitor[j].tag !== undefined && liveListMonitor[j].tag !== null) {
            modifiedLiveList[i].tag = liveListMonitor[j].tag;
          }
        }
      }

    }

    return modifiedLiveList;
  };

  this.getFormatedAmplitudeForFaded = function (deviceAmplitude, hasWaveProblem) {
    if (deviceAmplitude > 0) {
      let sum = 0;
      let num = parseFloat(deviceAmplitude.toFixed(2)) * 100;
      let numString = num.toFixed(0);

      for (let k = 0; k < numString.length; k++) {
        sum += parseInt(numString[k], 10);
      }

      if (hasWaveProblem) {
        if (sum % 2 === 0) {
          if (num === 349 || num === 749 || num === 249) {
            num = num - 1;
          }
          else {
            if (numString[numString.length - 1] === "9") {
              num = num - 1;
            }
            else {
              num = num + 1;
            }
          }
        }
      }
      else {
        if (sum % 2 !== 0) {
          if (num === 349 || num === 749 || num === 249) {
            num = num - 1;
          }
          else {
            if (numString[numString.length - 1] === "9") {
              num = num - 1;
            }
            else {
              num = num + 1;
            }
          }
        }
      }

      return (num / 100).toFixed(2);
    }
    else {
      return deviceAmplitude;
    }
  };

  this.getRequestPrefix = (problemType, Constants) => {
    if (problemType === Constants.RETRIES_ERROR_TYPE
      || problemType === Constants.DIAGNOSTIC_ERROR_TYPE
      || problemType === Constants.FAULT_ERROR_TYPE
      || problemType === Constants.FAULT_SEQUENCE_ERROR_TYPE
      || problemType === Constants.CONFIG_ERROR_TYPE
      || problemType === Constants.PARAM_ERROR_TYPE
      || problemType === Constants.MISSING_ERROR_TYPE
      || problemType === Constants.ONLINE_ERROR_TYPE
      || problemType === Constants.CRITICAL_SLAVE_ERROR_TYPE
      || problemType === Constants.MASTER_FAULT_ERROR_TYPE
      || problemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE
      || problemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE
      || problemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE
    ) {
      return Constants.MONITOR_REQUEST_IP_ADDRESS;
    }
    else if (problemType === Constants.TERMINATION_OFF_PROBLEM_TYPE
      || problemType === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE
      || problemType === Constants.HIGH_RESISTANCE_PROBLEM_TYPE
      || problemType === Constants.A_NOT_OK_PROBLEM_TYPE
      || problemType === Constants.B_NOT_OK_PROBLEM_TYPE
      || problemType === Constants.LONG_CABLE_PROBLEM_TYPE
      || problemType === Constants.NOISE_PROBLEM_TYPE
      || problemType === Constants.REFLECTION_PROBLEM_TYPE
    ) {
      return Constants.ANALYZER_REQUEST_IP_ADDRESS;
    }
  };

  this.s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  };

  this.formatToRelativeTime2 = (uptimeInSeconds, UtilsInstance, Strings) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return UtilsInstance.getDateTimeSince2(new Date(dateWhenWasTurnedOn), UtilsInstance, Strings);
    }
  };

  this.getDateTimeSince2 = (target, UtilsInstance, Strings) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += UtilsInstance.getDaysInMonth2(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) out.push(md + Strings.MOUTH + (md === 1 ? "" : "s"));
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    if (sd > 0) out.push(sd + Strings.SECOND_T + (sd === 1 ? "" : "s"));
    return out.join(" ");
  };

  this.getDaysInMonth2 = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  };

  this.whenWasTurnedOnAsDate = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return dateWhenWasTurnedOn;
    }
  };

  this.getMonitorInitTime = (uptime, UtilsInstance) => {
    let drawDate = UtilsInstance.whenWasTurnedOnAsDate(uptime);
    let year = drawDate.getFullYear();
    let month = drawDate.getMonth() + 1;
    let day = drawDate.getDate();
    let hour = drawDate.getHours();
    let minutes = drawDate.getMinutes();
    let seconds = drawDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds;
  };

  this.getMasterStatusText = (masterStatus) => {
    if (masterStatus !== "") {
      return `- ${masterStatus[0].toUpperCase() + masterStatus.slice(1)}`;
    }
  };

  this.getLanguageStringFromKey = (Constants, Strings) => {
    let langKey = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    if (langKey === Constants.ES_LANG_KEY) {
      return Strings.SPANISH;
    }
    else if (langKey === Constants.EN_LANG_KEY) {
      return Strings.ENGLISH;
    }
    else if (langKey === Constants.DE_LANG_KEY) {
      return Strings.GERMAN;
    }
    else {
      return Strings.PORTUGUESE;
    }
  };

  this.replacePointWithComma = (str) => {
    return str.replace(".", ",");
  };
}